const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106 106",
    style: {
      enableBackground: "new 0 0 106 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e4e4e4"
    },
    cx: 53,
    cy: 53,
    r: 53
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc"
    },
    d: "M70.8 24H30v56.3h40.8c3.1 0 5.6-2.5 5.6-5.6V29.6c0-3.1-2.5-5.6-5.6-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf"
    },
    d: "m49.9 24 2.5 26.9-2.5 29.4H30V24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d"
    },
    d: "M69.8 29.6v45.2c0 3.1-2.6 5.6-5.7 5.6H49.9V24h14.2c3.1 0 5.6 2.5 5.7 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8"
    },
    d: "M49.9 62.1h8.3v3.3h-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc"
    },
    d: "M41.6 62.1h8.3v3.3h-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8"
    },
    d: "M49.9 68.7h4.9V72h-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc"
    },
    d: "M44.9 68.7h5V72h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M49.9 33.9v-3.3c-7.3 0-13.3 5.9-13.3 13.2 0 7.3 5.9 13.3 13.2 13.3v-3.3c-.2 0-.9-.6-1.6-2.3-.7-1.9-1-4-1.1-6h2.7v-3.3h-2.7c.1-2 .5-4 1.1-6 .8-1.7 1.5-2.3 1.7-2.3zm-9.8 11.6h3.8c.1 2.4.5 4.8 1.3 7.1-2.7-1.4-4.6-4-5.1-7.1zm3.8-3.3h-3.8c.5-3 2.4-5.7 5.1-7.1-.8 2.3-1.3 4.7-1.3 7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eee"
    },
    d: "M49.9 30.6v3.3c.2 0 .9.5 1.6 2.3.7 1.9 1.1 3.9 1.1 6h-2.7v3.3h2.7c-.1 2-.5 4.1-1.1 6-.7 1.8-1.4 2.3-1.6 2.3v3.3c7.3 0 13.2-5.9 13.2-13.2s-5.9-13.2-13.2-13.3zm9.8 11.6h-3.8c-.1-2.4-.5-4.8-1.3-7.1 2.7 1.5 4.6 4.1 5.1 7.1zm-5.1 10.4c.8-2.3 1.3-4.7 1.3-7.1h3.8c-.5 3.1-2.4 5.7-5.1 7.1z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportCircle);
export default __webpack_public_path__ + "static/media/passport-circle.9a5ef7533d3b80b8e489601deda47b9b.svg";
export { ForwardRef as ReactComponent };